module.exports = __webpack_public_path__ + "img/tip-blod.1536394e.png";